import React, { useEffect, useContext, useMemo } from "react";
import { cloneDeep } from "lodash/fp";
import client from "client";
import { useLazyQuery } from "@apollo/client";
import Uri from "jsuri";

import { SourceContext } from "pages/SourcePage/SourcesMasterPage";
import { QUERY_getPages } from "pages/SourcePage/SourcesQueries";
import SourceList from "pages/SourcePage/SourceList";

import { FaShareAlt } from "react-icons/fa";
import Heading from "components/Elements/Heading";
import { HEADERS } from "components/Utils/Constants";
import Loader from "components/Loader/Loader";

const Sources = (url) => {
  const sourceProps = useContext(SourceContext);
  const props = useMemo(() => sourceProps, [sourceProps]);

  const [getPages] = useLazyQuery(QUERY_getPages, { client });

  const oauth_token = new Uri(url.location.search).getQueryParamValue(
    "oauth_token"
  );
  const oauth_verifier = new Uri(url.location.search).getQueryParamValue(
    "oauth_verifier"
  );

  const tiktok_code = new Uri(url.location.search).getQueryParamValue("code");
  const tiktok_state = new Uri(url.location.search).getQueryParamValue("state");
  const tiktok_error = new Uri(url.location.search).getQueryParamValue(
    "error_description"
  );

  //getting the access_token and calling query
  const hash = window.location.hash.substring(1);
  const params = {};
  hash.split("&").map((hk) => {
    const temp = hk.split("=");
    return (params[temp[0]] = temp[1]);
  });
  const access_token = params.access_token;

  useEffect(() => {
    sendData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderSources = () => {
    if (props.data) {
      const data = cloneDeep({
        ...props.data,
      });
      return data.connectors
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((data, i) => (
          <SourceList name={data.name} key={i} sourceData={data} />
        ));
    }
    if (props.loading) {
      return <Loader minHeight={500} col={"col-1"} size="circle-scale--sm" />;
    }
    if (props.error) return <div>{props.error.message}</div>;
  };

  const sendData = async () => {
    if (tiktok_code && tiktok_state) {
      const TOKEN = window.localStorage.token;
      const url = "https://api-production.pickaxe.ai/api/auth/tiktok";
      fetch(url, {
        method: "POST",
        headers: HEADERS(TOKEN),
        body: JSON.stringify({
          auth_code: tiktok_code,
          auth_state: tiktok_state,
          message: tiktok_error,
          tenantID: parseInt(localStorage.defaultTenantID),
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          props.refetchSources();
        });
    } else if (oauth_token && oauth_verifier) {
      const TOKEN = window.localStorage.token;
      const url = "https://api-production.pickaxe.ai/api/auth/twitter";
      fetch(url, {
        method: "POST",
        headers: HEADERS(TOKEN),
        body: JSON.stringify({
          oauth_token: oauth_token,
          oauth_verifier: oauth_verifier,
          source_id: 1,
          tenantID: parseInt(localStorage.defaultTenantID),
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          props.refetchSources();
        });
    } else if (access_token) {
      getPages({
        variables: {
          fbAccessToken: access_token,
          tenantID: parseInt(localStorage.defaultTenantID),
        },
      });
    }
  };

  return (
    <div className="container-fluid">
      <main className="container-main">
        <div className="d-flex flex-row">
          <div className="pb-5 w-100 bg-light">
            <div className="shadow-sm pt-4 m-4 h-100 bg-white">
              <div className="p-4 d-flex justify-content-between">
                <Heading size={4} className="title">
                  Your Sources
                </Heading>
              </div>

              <div className="sources-border-between"></div>

              <div className="source-list px-4 pb-2">{renderSources()}</div>

              <div className="small-text  text-center">
                <FaShareAlt size="1.7rem" />
                <Heading size={4} className="pt-4 pb-2">
                  More Connectors Coming Soon
                </Heading>
                <small>
                  Soon, all of your connectors will be available to administered
                  here. We will let <br />
                  you know as we add more connector controls to the admin panel.
                </small>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
export default Sources;
